export const Zindexes = {
    supportButtons: 12,
    npsSurvey: 99,
    stickyHeader: 99,
    dropdownMenu: 900,
    blogDialogContainer: 901,
    asyncOverlay: 901,
    signUp: 949,
    universalNav: 950,
    universalTopbarMegaDropdown: 960,
    popover: 1002,
    editorErrorList: 1002,
    modalOverlay: 2000,
    headerFixedPosition: 10000,
    pageNotification: 10100,
    perfReport: 1000000,
    fixedSurvey: 1000201,
};
//# sourceMappingURL=Zindexes.js.map
// @zapier/design-system@5.26.3 (1a8819ee6)
